import { CultureInfo } from '../culture-info.model';
import { CultureInfoAr } from './ar';

/**
 * @ignore
 */
export const CultureInfoArDZ: CultureInfo = {
  name: 'ar-DZ',
  displayName: 'Arabic (Algeria)',
  iso3LanguageCode: 'ara',
  iso2LanguageCode: 'ar',
  ietfLanguageTag: 'ar-DZ',
  parent: CultureInfoAr
};
